import {
  Chip,
  ChipItemValueItem,
  ChipItemValuesList,
  ChipSeparator,
  ChipItemFacet,
  ChipItemClose,
  ChipItem,
} from '@src/design-system/chip';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import type { TReminderTemplate } from '@src/shared/types/reminder-template';
import { useSearchParams } from 'react-router-dom';

export default function ReminderContentTypeChip() {
  const [sp, setSp] = useSearchParams();
  const selectedContentType = sp.get(
    'content_type'
  ) as TReminderTemplate['content_type'];

  if (!selectedContentType) return null;

  return (
    <Chip>
      <ChipItem className='h-[40px]'>
        <ChipItemClose
          onClick={() =>
            setSp((prev) => {
              prev.delete('content_type');
              return prev;
            })
          }
        />
        <ChipItemFacet>Type</ChipItemFacet>
        <ChipSeparator />
        <ChipItemValuesList>
          <ChipItemValueItem>
            {formatTextForDisplay(selectedContentType)}
          </ChipItemValueItem>
        </ChipItemValuesList>
      </ChipItem>
    </Chip>
  );
}
